import { theme } from '@bechtel/gds';
import styled from 'styled-components';

export const IntialStyledContainer = styled.div`
  height: 97vh;
  width: 100%;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
`;
export const IntialStyledLogo = styled.div`
  height: 60vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const VersionContainerStyled = styled.div`
  width: 16%;
  display: flex;
  justify-content: flex-end;
`;
export const VersionStyled = styled.span`
  color: ${theme.colors.grey[700]};
  font-family: ${theme.fontFamilies.openSans};
  font-size: 18px;
`;
